"use strict";
// Moved from Trackly.WebClient/src/services/TeamService/types.ts (T013).
// TypeScript types based on backend Team view models
Object.defineProperty(exports, "__esModule", { value: true });
